module.exports = __webpack_public_path__ + "static/media/succeed4.def86dc5.jpg";